(function () {
  'use strict';

  var money = function (cents) {
    var s = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s.replace(/,00$/, '') + ' €';
  };

  function init(root) {
    if (root.dataset.msaReady) return;
    root.dataset.msaReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Reveal ---------- */
    var targets = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---------- Purchase state ----------
       Offer card: Doppelpack (tier 2, combo mix / 2× her / 2× him) or 1 Kalender (tier 1 + edition).
       From `min` calendars every calendar costs `deal` (automatic discount in the cart). */
    var ids = { her: root.dataset.herId, him: root.dataset.himId };
    var avail = { her: root.dataset.herAvailable === 'true', him: root.dataset.himAvailable === 'true' };
    var titles = { her: root.dataset.herTitle, him: root.dataset.himTitle };
    var full = parseInt(root.dataset.full, 10);
    var deal = parseInt(root.dataset.deal, 10);
    var dealMin = parseInt(root.dataset.min, 10);
    var other = function (e) { return e === 'her' ? 'him' : 'her'; };
    var state = { ed: root.dataset.ed || 'her', duo: true, second: null };

    var params = new URLSearchParams(window.location.search);
    if (params.get('edition') === 'her' || params.get('edition') === 'him') state.ed = params.get('edition');
    if (params.get('variant') === ids.him) state.ed = 'him';
    if (params.get('variant') === ids.her) state.ed = 'her';
    state.second = other(state.ed);

    function picks() { return state.duo ? [state.ed, state.second] : [state.ed]; }
    function items() {
      var counts = {};
      picks().forEach(function (e) { counts[e] = (counts[e] || 0) + 1; });
      return Object.keys(counts).map(function (e) { return { id: Number(ids[e]), quantity: counts[e] }; });
    }
    function label() {
      var p = picks();
      if (p.length === 1) return titles[p[0]];
      if (p[0] === p[1]) return '2× ' + titles[p[0]];
      return titles[p[0]] + ' + ' + titles[p[1]];
    }

    var lastEd = null;
    function render() {
      root.dataset.ed = state.ed;
      root.querySelectorAll('[data-ed-btn]').forEach(function (b) {
        if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', b.dataset.edBtn === state.ed ? 'true' : 'false');
      });
      root.querySelectorAll('[data-tier]').forEach(function (t) {
        t.setAttribute('aria-checked', (t.dataset.tier === '2') === state.duo ? 'true' : 'false');
      });
      root.querySelectorAll('[data-tier-second]').forEach(function (s) { s.hidden = !state.duo; });
      root.querySelectorAll('[data-tier-single]').forEach(function (s) { s.hidden = state.duo; });
      var combo = state.ed === state.second ? state.ed : 'mix';
      root.querySelectorAll('[data-combo]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.combo === combo ? 'true' : 'false'); });
      root.querySelectorAll('[data-combo]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.dataset.combo;
        state.duo = true;
        if (c === 'mix') { state.second = other(state.ed); } else { state.ed = c; state.second = c; }
        render();
      });
    });
    root.querySelectorAll('[data-second]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.second === state.second ? 'true' : 'false'); });
      root.querySelectorAll('[data-ed-name]').forEach(function (el) { el.textContent = titles[state.ed]; });

      var galKey = state.ed + (state.duo && combo === 'mix' ? '-duo' : '');
      if (lastEd !== galKey) {
        var firstRender = lastEd === null;
        lastEd = galKey;
        var set = '[data-gal="' + state.ed + '"] ';
        var first = (state.duo && combo === 'mix' && root.querySelector(set + '[data-duo]')) || root.querySelector(set + '[data-media]:not([data-duo])');
        if (first && !(firstRender && first.hasAttribute('data-duo'))) showMedia(first);
        else if (first) root.querySelectorAll('[data-gal] [data-media]').forEach(function (x) { x.classList.toggle('is-active', x === first); });
      }

      var list = picks();
      var count = list.length;
      var dealOn = count >= dealMin && deal < full;
      var now = count * (dealOn ? deal : full);
      var was = count * full;
      root.querySelectorAll('[data-now]').forEach(function (el) { el.textContent = money(now); });
      root.querySelectorAll('[data-was]').forEach(function (el) { el.textContent = money(was); });
      root.querySelectorAll('[data-was-wrap]').forEach(function (el) { el.hidden = !dealOn; });
      root.querySelectorAll('[data-qty-name]').forEach(function (el) { el.textContent = count + ' Stück'; });
      root.querySelectorAll('[data-unit]').forEach(function (el) { el.textContent = dealOn ? '= ' + money(deal) + ' pro Kalender' : ''; el.hidden = !dealOn; });
      root.querySelectorAll('[data-off]').forEach(function (el) { el.textContent = '−' + Math.round((was - now) / was * 100) + ' %'; el.hidden = !dealOn; });
      root.querySelectorAll('[data-tax]').forEach(function (el) {
        el.textContent = dealOn ? 'Du sparst ' + money(was - now) + ' · inkl. MwSt. · kostenloser Versand' : 'inkl. MwSt. · kostenloser Versand';
      });
      root.querySelectorAll('[data-label]').forEach(function (el) { el.textContent = label(); });
      root.querySelectorAll('[data-good]').forEach(function (el) {
        if (dealOn) { el.textContent = '✓ Gute Wahl! Du sparst ' + money(was - now) + '.'; el.classList.remove('is-upsell'); return; }
        el.classList.add('is-upsell');
        el.innerHTML = '';
        if (deal * dealMin - full <= 0 || dealMin !== 2) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = 'Nur <b>+' + money(deal * dealMin - full) + '</b> und du bekommst 2 Kalender →';
        b.addEventListener('click', function () { state.duo = true; state.second = other(state.ed); render(); });
        el.appendChild(b);
      });

      var ok = list.every(function (e) { return avail[e]; });
      root.querySelectorAll('[data-submit]').forEach(function (b) {
        b.disabled = !ok;
        b.textContent = ok ? 'In den Warenkorb · ' + money(now) : 'Ausverkauft';
        if (b.dataset.short) b.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
      });
    }

    root.querySelectorAll('[data-ed-btn]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (b.tagName === 'A') e.preventDefault();
        if (state.ed !== b.dataset.edBtn) { state.ed = b.dataset.edBtn; state.second = other(state.ed); }
        render();
        if (b.hasAttribute('data-go-buy')) goBuy();
      });
    });
    root.querySelectorAll('[data-tier]').forEach(function (t) {
      var pick = function () { state.duo = t.dataset.tier === '2'; render(); };
      t.addEventListener('click', function (e) { if (!e.target.closest('[data-second], [data-combo], [data-ed-btn]')) pick(); });
      t.addEventListener('keydown', function (e) { if (e.target === t && (e.key === ' ' || e.key === 'Enter')) { e.preventDefault(); pick(); } });
    });
    root.querySelectorAll('[data-second]').forEach(function (b) {
      b.addEventListener('click', function () { state.second = b.dataset.second; state.duo = true; render(); });
    });
    function goBuy() {
      var t = root.querySelector('#msa-kaufen');
      if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    root.querySelectorAll('[data-go-buy]').forEach(function (a) {
      if (a.hasAttribute('data-ed-btn')) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (a.dataset.goBuy === 'duo') state.duo = true;
        render();
        goBuy();
      });
    });

    /* ---------- Gallery ---------- */
    var main = root.querySelector('[data-gal-main]');
    var mediaStart = parseFloat(root.dataset.videoStart) || 0;
    function showMedia(btn) {
      if (!main) return;
      var set = btn.closest('[data-gal]');
      root.querySelectorAll('[data-gal] [data-media]').forEach(function (x) { x.classList.toggle('is-active', x === btn); });
      main.querySelectorAll('img, video').forEach(function (el) { el.remove(); });
      main.classList.toggle('msa-pack', btn.dataset.pack === 'true');
      var el;
      if (btn.dataset.type === 'video') {
        el = document.createElement('video');
        el.muted = true; el.playsInline = true; el.setAttribute('playsinline', ''); el.autoplay = true; el.preload = 'auto';
        if (btn.dataset.poster) el.poster = btn.dataset.poster;
        el.src = btn.dataset.media;
        el.addEventListener('loadedmetadata', function () { try { el.currentTime = mediaStart; } catch (e) {} });
        el.addEventListener('timeupdate', function () { if (el.duration && el.currentTime >= el.duration - 0.12) el.currentTime = mediaStart; });
        if (reduce) el.autoplay = false;
      } else {
        el = document.createElement('img');
        el.src = btn.dataset.media;
        el.alt = btn.getAttribute('aria-label') || '';
      }
      main.appendChild(el);
      if (el.tagName === 'VIDEO' && !reduce) el.play().catch(function () {});
      if (set) set.dataset.current = btn.dataset.media;
    }
    root.querySelectorAll('[data-gal] [data-media]').forEach(function (b) {
      b.addEventListener('click', function () { showMedia(b); });
    });
    function stepMedia(dir) {
      var list = Array.prototype.slice.call(root.querySelectorAll('[data-gal="' + state.ed + '"] [data-media]'));
      if (!list.length) return;
      var i = list.findIndex(function (x) { return x.classList.contains('is-active'); });
      var next = list[(i + dir + list.length) % list.length];
      showMedia(next);
      next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    root.querySelectorAll('[data-gal-prev]').forEach(function (b) { b.addEventListener('click', function () { stepMedia(-1); }); });
    root.querySelectorAll('[data-gal-next]').forEach(function (b) { b.addEventListener('click', function () { stepMedia(1); }); });
    if (main) {
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) stepMedia(dx < 0 ? 1 : -1);
        sx = null;
      });
    }

    /* ---------- Benefit slider arrows ---------- */
    root.querySelectorAll('[data-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('.msa-slider');
      wrap.querySelectorAll('[data-slide]').forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: (b.dataset.slide === 'next' ? 1 : -1) * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });

    /* ---------- Add to cart ---------- */
    var msg = root.querySelector('[data-msg]');
    root.querySelectorAll('[data-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        btn.disabled = true;
        if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items() })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Das hat leider nicht geklappt.');
            window.location.href = base + 'cart';
          })
          .catch(function (err) {
            if (msg) { msg.textContent = err.message; msg.classList.add('is-error'); }
            render();
          });
      });
    });

    /* ---------- Film: start at video_start, play only while visible ---------- */
    root.querySelectorAll('.msa-film video').forEach(function (v) {
      v.removeAttribute('autoplay');
      var seek = function () { try { if (v.currentTime < mediaStart) v.currentTime = mediaStart; } catch (e) {} };
      if (v.readyState >= 1) seek(); else v.addEventListener('loadedmetadata', seek);
      v.addEventListener('timeupdate', function () { if (v.duration && v.currentTime >= v.duration - 0.12) v.currentTime = mediaStart; });
      if (reduce || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && v.offsetParent) v.play().catch(function () {}); else v.pause();
      }, { threshold: 0.25 }).observe(v);
    });
    root.querySelectorAll('[data-ed-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.msa-film video').forEach(function (v) {
          var r = v.getBoundingClientRect();
          if (v.offsetParent && r.top < innerHeight && r.bottom > 0) v.play().catch(function () {});
        });
      });
    });

    /* ---------- Sticky add-to-cart ---------- */
    var sticky = root.querySelector('.msa-sticky');
    var cta = root.querySelector('.msa-cta');
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(cta);
    }

    /* ---------- Countdown ---------- */
    var cdEls = root.querySelectorAll('[data-countdown]');
    var cdTarget = root.dataset.presaleEnd ? new Date(root.dataset.presaleEnd).getTime() : NaN;
    if (cdEls.length && !isNaN(cdTarget)) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var diff = Math.max(cdTarget - Date.now(), 0);
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        var txt = (d > 0 ? d + ' Tage ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        cdEls.forEach(function (el) {
          if (el.dataset.countdown === 'units') {
            el.innerHTML = '<span><b>' + d + '</b>Tage</span><span><b>' + pad(h) + '</b>Std.</span><span><b>' + pad(m) + '</b>Min.</span><span><b>' + pad(s) + '</b>Sek.</span>';
          } else {
            el.textContent = txt;
          }
        });
      };
      tick();
      setInterval(tick, 1000);
    } else {
      root.querySelectorAll('[data-countdown-wrap]').forEach(function (w) { w.hidden = true; });
    }

    render();
  }

  function boot() { document.querySelectorAll('.msa').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
